import request from '@/utils/request'
import requeststr from '@/utils/requeststr'
import qs from 'qs'
const BASE_URL = '/PrTestRework'

//类别
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(data) {
    console.log('data', data)
    return requeststr({
      url: BASE_URL + '/Info',
      method: 'post',
      data: qs.stringify(data)
    })
  },
  getWorkDocTestFailList(data){
    return request({
      url: BASE_URL + '/GetWorkDocTestFailList',
      method: 'post',
      data
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  updateRework(data){
    return request({
      url: BASE_URL + '/UpdateRework',
      method: 'post',
      data
    })
  }
}